module.exports = function getResource(label) {
    let resources = {
        storeDetails: 'Détails du magasin'
    };

    return resources[label];
};
